import { render, staticRenderFns } from "./ContactsDlg.vue?vue&type=template&id=2cb52a58&"
import script from "./ContactsDlg.vue?vue&type=script&lang=js&"
export * from "./ContactsDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports